import React, { useEffect, useState } from "react";
import { createContainer } from "unstated-next";
import { useChat } from ".";

const useContainer = () => {
  const { infoPanelActive, setInfoPanelActive, activePubnubChannel } =
    useChat();
  const [open, setOpen] = useState<"THREAD" | "PINS" | "INSIGHT" | false>(
    false
  );
  const [title, setTitle] = useState<string | React.JSX.Element>("");
  const [subtitle, setSubtitle] = useState("");

  useEffect(() => {
    if (infoPanelActive) {
      setOpen(false);
    }
  }, [infoPanelActive]);

  useEffect(() => {
    if (open) {
      setInfoPanelActive(false);
    }
  }, [open]);

  useEffect(() => {
    setOpen((current) => (current === "INSIGHT" ? false : current));
  }, [activePubnubChannel]);

  return {
    open,
    setOpen,
    title,
    setTitle,
    subtitle,
    setSubtitle,
  };
};

export const {
  useContainer: useChatSidePanel,
  Provider: ChatSidePanelProvider,
} = createContainer(useContainer);
